import React from "react"

import { Color } from "../../../../constants/V2/color"
import CircleCheckIcon from "../../../elements/V2/Icons/CircleCheckIcon"
import Typography from "../../../elements/V2/Typography"

export const InfoSectionSupportSubscript = () => (
  <div className="flex items-center gap-2">
    <CircleCheckIcon
      opacity={1}
      checkmarkClassName="stroke-blue"
      borderClassName="stroke-blue"
    />
    <Typography
      font="grotesk"
      size="body-sm"
      weight="book"
      color={Color.Black}
      text="Get 24/7 support, 1 year warranty and a 30 day guarantee."
    />
  </div>
)
